import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
import { createSelector } from 'reselect';
import { getSelectedModuleSchema } from 'ContentEditorUI/redux/selectors/selectionSelectors';
export const getModuleVersions = basicSelector(state => state.moduleVersions);
export const getModuleHasUpgradeAvailable = createSelector(getSelectedModuleSchema, getModuleVersions, (moduleSchema, moduleVersions) => {
  const modulesWithVersionUpgrades = moduleVersions && moduleVersions.upgradableAssets;
  const moduleSchemaPath = moduleSchema && moduleSchema.path;
  return moduleSchemaPath && modulesWithVersionUpgrades && modulesWithVersionUpgrades[moduleSchemaPath];
});